import React from 'react';
import './stale-banner.scss';

function StaleBanner(props) {
  var lastActive   = props.lastActive;
  var onNewSession = props.onNewSession;
  var onDismiss    = props.onDismiss;

  var hoursAgo = lastActive
    ? Math.round((Date.now() - lastActive) / (1000 * 60 * 60))
    : null;

  var label = hoursAgo !== null
    ? (hoursAgo >= 24
        ? Math.floor(hoursAgo / 24) + (Math.floor(hoursAgo / 24) === 1 ? ' day' : ' days') + ' ago'
        : hoursAgo + (hoursAgo === 1 ? ' hour' : ' hours') + ' ago')
    : 'earlier';

  return (
    <div className="stale-session-banner">
      <div className="stale-banner-icon">⚠️</div>
      <div className="stale-banner-text">
        <strong>Session from {label}.</strong>{' '}
        The AI context may have expired — starting a query here may produce unexpected results.
      </div>
      <div className="stale-banner-actions">
        <button className="stale-banner-new" onClick={onNewSession}>
          Start New Session
        </button>
        <button className="stale-banner-dismiss" onClick={onDismiss}>
          Continue Anyway
        </button>
      </div>
    </div>
  );
}

export default StaleBanner;
